/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AdminOverview } from '../../components/admin-dashboard/AdminOverview';
import { AdminSurveyRoute } from './AdminSurveyRoute';
import { AdminUserRoute } from './AdminUserRoute';
import './styles.scss'
import { AdminQuestionRoute } from './AdminQuestionRoute';
import { companyTrackerInitiativeRoutes } from '../../../../routes/company-tracker/routes';
import { AdminQuestionValueListRoute } from './AdminQuestionValueListRoute';

const adminDashboardRoute = companyTrackerInitiativeRoutes.ADMIN_DASHBOARD;

export function AdminDashboardRoute() {
  return (
    <Switch>
      <Route path={`${adminDashboardRoute.path}/questions/:utrId/dropdown-options`}>
        <AdminQuestionValueListRoute />
      </Route>
      <Route path={`${adminDashboardRoute.path}/questions`}>
        <AdminQuestionRoute />
      </Route>
      <Route path={`${adminDashboardRoute.path}/users/:userId`}>
        <AdminUserRoute />
      </Route>
      <Route path={`${adminDashboardRoute.path}/overview/:surveyId`}>
        <AdminSurveyRoute />
      </Route>
      <Route>
        <AdminOverview />
      </Route>
    </Switch>
  );
}

